import Vue from 'vue';

export const EventBus = new Vue()
export const HttpErrorEvent = 'http:error'
export const ApplyToListChangedDataEvent = 'applyto:changed'
export const PageRefreshEvent = 'page:refresh'
